import React, { useEffect, useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Layout Components
import AdminSidebar from './components/AdminSidebar'
import AdminTopbar from './components/AdminTopbar'

// Admin Pages
import Dashboard from './AdminPages/Dashboard'
import Plans from './AdminPages/Plans'
import Inventory from './AdminPages/Inventory'
import Reports from './AdminPages/Reports'

// User Pages
// import UserDashboard from "./userpages/UserDashboard"
// import UserProfile from "./userpages/UserProfile"
// import UserPlans from "./userpages/UserPlans"

// Public Pages
import MemberLogin from './HomePages/MemberLoginModal'
import AdminLogin from './HomePages/AdminLogin'
import UserRegistration from './HomePages/UserRegistration'
import SwimWay from './HomePages/SwimWay'
import BookSlot from './UserPages/BookSlot'
import UserSidebar from './components/UserSidebar'
import UserTopbar from './components/UserTopbar'
// import UserQRCode from './UserPages/UserQRCode'
import PaymentPage from './UserPages/PaymentPage'
import UserProfile from './UserPages/UserProfile'
import ViewQRCode from './UserPages/ViewQRCode'
import TermsCondition from './HomePages/TermsCondition'
// import UserTypeMaster from './AdminPages/Master/UserTypeMaster'
import SlotMaster from './AdminPages/Master/SlotMaster'
import TermsAndConditionMaster from './AdminPages/Master/TermsAndConditionMaster'
import LifeTimeMembershipMaster from './AdminPages/Master/LifeTimeMembershipMaster'
import FeeMaster from './AdminPages/Master/FeeMaster'
import EmployeeMaster from './AdminPages/Master/EmployeeMaster'
import FeeAllocation from './AdminPages/Transaction/FeeAllocation'
import PhotoUpdate from './AdminPages/Transaction/PhotoUpdate'
import TicketBooking from './AdminPages/Transaction/TicketBooking'
import CardPrinting from './AdminPages/Transaction/CardPrinting'
import TodaysOfflineBooking from './AdminPages/Transaction/TodaysOfflineBooking'
import TodaysOnlineBooking from './AdminPages/Transaction/TodaysOnlineBooking'
import FeeCollection from './AdminPages/Transaction/FeeCollection'

function App() {
  const [AssignedRole, setAssignedRole] = useState(
    sessionStorage.getItem('role'),
  )
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Re-sync role whenever sessionStorage changes
  useEffect(() => {
    const syncRole = () => setAssignedRole(sessionStorage.getItem('role'))
    window.addEventListener('storage', syncRole)
    return () => window.removeEventListener('storage', syncRole)
  }, [])

  return (
    <Routes>
      {/* Public Routes */}

      <Route path="/" element={<SwimWay />} />

      <Route path="/register" element={<UserRegistration />} />

      <Route path="/member-login" element={<MemberLogin />} />

      <Route path="/admin-login" element={<AdminLogin />} />

      <Route path="/terms-condition" element={<TermsCondition />} />

      {/* Admin Routes */}

      {AssignedRole === 'Admin' && (
        <Route
          path="/admin/*"
          element={
            <div className="app-layout">
              <AdminSidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
              />

              <div className="main-content">
                <AdminTopbar onMenuClick={() => setSidebarOpen(true)} />

                <main className="page-body">
                  <Routes>
                    <Route path="ad-dashboard" element={<Dashboard />} />
                    {/* =========Master Pages========= */}
                    {/* <Route path="m-userType" element={<UserTypeMaster />} /> */}
                    <Route path="m-slot" element={<SlotMaster />} />
                    <Route path="m-terms_condition" element={<TermsAndConditionMaster />} />
                    <Route path="m-life_time_member" element={<LifeTimeMembershipMaster />} />
                    <Route path="m-fee" element={<FeeMaster />} />
                    <Route path="m-employee" element={<EmployeeMaster />} />
                    
                    {/* =========Transaction Pages========= */}
                    <Route path="t-fee_allocation" element={<FeeAllocation />} />
                    <Route path="t-photo_update" element={<PhotoUpdate />} />
                    <Route path="t-ticket_booking" element={<TicketBooking />} />
                    <Route path="t-card_printing" element={<CardPrinting />} />
                    <Route path="t-today_off_book" element={<TodaysOfflineBooking />} />
                    <Route path="t-today_on_book" element={<TodaysOnlineBooking />} />
                    <Route path="t-fee_collection" element={<FeeCollection />} />

                    {/* =========Other Pages========= */}
                    <Route path="plans" element={<Plans />} />
                    <Route path="inventory" element={<Inventory />} />
                    <Route path="reports" element={<Reports />} />

                    <Route
                      path="*"
                      element={<Navigate to="/admin/ad-dashboard" />}
                    />
                  </Routes>
                </main>
              </div>
            </div>
          }
        />
      )}

      {/* User Routes */}

      {AssignedRole === 'User' && (
        <Route
          path="/user/*"
          element={
            <div className="app-layout">
              <UserSidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
              />

              <div className="main-content">
                <UserTopbar onMenuClick={() => setSidebarOpen(true)} />

                <main className="page-body">
                  <Routes>
                    <Route path="user-bookslot" element={<BookSlot />} />
                    <Route path="user-payment" element={<PaymentPage />} />
                    {/* <Route path="user-qrcode" element={<UserQRCode />} /> */}
                    <Route path="qr-view" element={<ViewQRCode />} />
                    <Route path="user-profile" element={<UserProfile />} />
                    <Route
                      path="*"
                      element={<Navigate to="/user/user-profile" />}
                    />
                  </Routes>
                </main>
              </div>
            </div>
          }
        />
      )}

      {/* Redirect unknown routes */}

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default App
